import { useLocation } from "react-router-dom";

export function useGetCurrentRoute() {
  const location = useLocation();
  return location.pathname;
}
